<div class="wrapper">

  <mat-card class="card">
    <mat-card-content>
      <h1>Settings</h1>
    </mat-card-content>
  </mat-card>
</div>